import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { BASE_OFFER_CHECKOUT_URL } from '../utils/checkout';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-bg-secondary/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-375" data-mp="2nvdnlp2p539x">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-376" data-mp="2swbceki7ovke">
        <div data-id="element-377" data-mp="o0kzcbgsnwf4">
          <p className="font-heading text-sm font-semibold text-white" data-id="element-378" data-mp="o0uro5pbafnz">17,90€</p>
          <p className="text-[11px] text-muted" data-id="element-379" data-mp="o2xnx7h25515">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" showArrow={false} href={BASE_OFFER_CHECKOUT_URL} data-id="element-380" data-mp="s497owd92w1f">
          Quiero el Manual
        </PrimaryButton>
      </div>
    </div>;
}